import { render, staticRenderFns } from "./marginInLog.vue?vue&type=template&id=4783f59e&scoped=true"
import script from "./marginInLog.vue?vue&type=script&lang=js"
export * from "./marginInLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783f59e",
  null
  
)

export default component.exports